export enum BinLocationFormatEnum {
  RACK_SHELF_BIN = 'rack_shelf_bin',
  RACK_BIN_SHELF = 'rack_bin_shelf',
}
